import { CloseIcon, IconButton } from "@carbon6/c6-frontend-design";
import styles from "./FilterResultChip.module.css";

type FilterResultChipProps = {
  label: string;
  /** 해제 버튼의 접근 이름. 라벨만으로는 무엇을 푸는 버튼인지 읽히지 않는다. */
  removeLabel: string;
  onRemove: () => void;
};

/**
 * 적용 중인 조회 조건 한 줄. 목록 화면의 적용 조건은 이 한 종류로만 세운다 — `LabelChip` 이나
 * 텍스트 ✕ 를 섞으면 같은 뜻이 화면마다 다른 모양으로 읽힌다(규칙 §13).
 */
export function FilterResultChip({ label, onRemove, removeLabel }: FilterResultChipProps) {
  return (
    <span className={styles.chip}>
      <span className={styles.label}>{label}</span>
      <IconButton aria-label={removeLabel} size="xs" variant="ghost" onClick={onRemove}>
        <CloseIcon />
      </IconButton>
    </span>
  );
}
